import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { AnalyticsIndexComposite } from "@/domains/analytics/index/components/composables/analytics-index-composite"
import { createBreadcrumbItem } from "@/domains/diagnostics/utils/breadcrumb-helpers"

export default function AnalyticsIndexPage() {
  return (
    <PageContainer>
      <MetaData title="Analytics" />
      <PageTitle
        title="Analytics"
        subTitle="Protocol analytics and insights"
        items={[
          createBreadcrumbItem("more", "More", "/"),
          createBreadcrumbItem("analytics", "Analytics", "/analytics", true),
        ]}
      />
      <AnalyticsIndexComposite />
    </PageContainer>
  )
}
